import React, { FC, ReactElement } from 'react'
import { ObserverCommentFormProps } from './types'
import { CommentForm } from '../CommentForm'
import { UserRole } from 'models/user/user'
import ObserverCommentFormMessages from './ObserverCommentForm.messages'

export const ObserverCommentForm: FC<ObserverCommentFormProps> = ({
  commentRecipients,
  orderCommentPath,
  showNotarySmsText,
  csrfToken,
  orderHasParticipants
}): ReactElement => {
  return (
    <CommentForm
      commentRecipients={commentRecipients}
      userRole={UserRole.Observer}
      showNotarySmsText={showNotarySmsText}
      toFieldHelpText={ObserverCommentFormMessages.TO.HELP}
      toFieldSelectText={ObserverCommentFormMessages.TO.SELECT}
      textFieldPlaceHolder={ObserverCommentFormMessages.TEXT.PLACEHOLDER}
      orderCommentPath={orderCommentPath}
      csrfToken={csrfToken}
      orderHasParticipants={orderHasParticipants}
    />
  )
}
